import script from "./adduser.vue?vue&type=script&setup=true&lang=js"
export * from "./adduser.vue?vue&type=script&setup=true&lang=js"

import "./adduser.vue?vue&type=style&index=0&id=5829399b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5829399b"]])

export default __exports__